import React, {Component} from 'react';

const RussianDisclaimer = () => {
    return (
        <div className="disclaimer">

            <h3>КОНТАКТНАЯ ИНФОРМАЦИЯ</h3>
            <br/>
            <p>По вопросам приобретения продукции для мастеров и салонов, сотрудничества и другим вопросам просим Вас писать на электронный адрес <a href="mailto:wellaprofrus@wella.com">wellaprofrus@wella.com</a> (Часы работы: Пн - Пт с 9:00 до 17:00 по Московскому времени).</p>
            <p>Если вы планируете отправить заявку на сотрудничество, просим Вас сначала ознакомиться с Политикой конфиденциальности (раздел Privacy Notice) на нашем сайте и в заявке, по возможности, предоставить данные:</p>
            <ul class="dashedList">
                <li>Имя и номер телефона контактного лица;</li>
                <li>В каком городе Вы находитесь (если г .Москва, укажите, пожалуйста, ближайшую станцию метро);</li>
                <li>Вы представляете салон, профессиональный магазин, интернет-магазин или являетесь частным мастером?;</li>
                <li>Если Вы представляете салон, укажите, пожалуйста, на какое количество кресел он рассчитан?;</li>
                <li>Kакие наши бренды Вас интересуют?</li>
            </ul>
            <br/><br/>
            <ol>
                <li>
                    <strong>Студия Москва:</strong><br/>
                    Ул. Валовая, 35<br/>
                    Студийный электронный адрес: <a href="mailto:Wella.MskStudio@wella.com">Wella.MskStudio@wella.com</a>;<br/>
                    Телефон студии: M +7 968 578 30 11 T +7 495 931 95 00
                </li>
                <li>
                    <strong>Студия Санкт-Петербург:</strong><br/>
                    Большой проспект, П.С., 84, лит. А<br/>
                    Студийный электронный адрес: <a href="mailto:Wella.SpbStudio@wella.com">Wella.SpbStudio@wella.com</a>;<br/>
                    Телефон студии: T +7 (812) 449 09 87
                </li>
                <li>
                    <strong>Студия Екатеринбург:</strong><br/>
                    Проспект Ленина, 50Б, офис 705<br/>
                    Студийный электронный адрес: <a href="mailto:Wella.EkbStudio@wella.com">Wella.EkbStudio@wella.com</a>;<br/>
                    Телефон студии: T +7 (343) 311-06-91
                </li>
                <li>
                    <strong>Студия Новосибирск:</strong><br/>
                    Красный проспект, 79/1<br/>
                    Студийный электронный адрес: <a href="mailto:Wella.NskStudio@wella.com">Wella.NskStudio@wella.com</a>;<br/>
                    Телефон студии: T +7 383 335 82 16 /18 /19; M +7 963 942 40 11
                </li>
                <li>
                    <strong>Студия Хабаровск:</strong><br/>
                    Ул. Тургенева, 46<br/>
                    Студийный электронный адрес: <a href="mailto:Wella.KhbStudio@wella.com">Wella.KhbStudio@wella.com</a><br/>
                    Телефон студии: T: +7 (4212) 410 250
                </li>
            </ol>
        </div>
    );
}

export default RussianDisclaimer;
